import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vShow as _vShow, withKeys as _withKeys, withModifiers as _withModifiers, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc5f44c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "roadmap-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "roadmap-header" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "roadmap-title" }, "2026 Roadmap")
], -1))
const _hoisted_3 = {
  key: 1,
  class: "error-container"
}
const _hoisted_4 = { class: "error-message" }
const _hoisted_5 = {
  key: 0,
  class: "error-type"
}
const _hoisted_6 = {
  key: 1,
  class: "retry-info mt-3"
}
const _hoisted_7 = { class: "timeline-container" }
const _hoisted_8 = { class: "event-count" }
const _hoisted_9 = { class: "event-count" }
const _hoisted_10 = {
  class: "timeline-scroll",
  ref: "timelineScroll"
}
const _hoisted_11 = { class: "timeline-months" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-line" }, null, -1))
const _hoisted_13 = { class: "timeline-events" }
const _hoisted_14 = { class: "month-popup-header" }
const _hoisted_15 = { class: "month-popup-content" }
const _hoisted_16 = {
  key: 0,
  class: "no-events-message"
}
const _hoisted_17 = {
  key: 1,
  class: "events-table"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Event")
  ])
], -1))
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "event-date" }
const _hoisted_21 = { class: "event-title" }
const _hoisted_22 = { class: "timeline-controls" }
const _hoisted_23 = { class: "event-modal-title" }
const _hoisted_24 = { class: "event-modal-controls" }
const _hoisted_25 = { class: "modal-event-date" }
const _hoisted_26 = { class: "event-description" }
const _hoisted_27 = {
  key: 0,
  class: "event-notes"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Notes:", -1))
const _hoisted_29 = {
  key: 1,
  class: "event-data"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Additional Data:", -1))
const _hoisted_31 = {
  key: 3,
  class: "empty-state"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "No roadmap data available", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "There are no events to display in the timeline.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimelineSkeleton = _resolveComponent("TimelineSkeleton")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_TimelineMonth = _resolveComponent("TimelineMonth")!
  const _component_TimelineEvent = _resolveComponent("TimelineEvent")!
  const _component_ErrorBoundary = _resolveComponent("ErrorBoundary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_TimelineSkeleton, { key: 0 }))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_v_card, {
              class: "error-card",
              elevation: "4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "error-title" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: "error",
                      size: "large",
                      class: "mr-3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-alert-circle")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" Unable to Load Roadmap ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.error.message || 'An unexpected error occurred while loading the roadmap data.'), 1),
                    (_ctx.error.type)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_v_chip, {
                            color: _ctx.getErrorTypeColor(_ctx.error.type),
                            size: "small",
                            variant: "tonal",
                            class: "mt-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getErrorTypeLabel(_ctx.error.type)), 1)
                            ]),
                            _: 1
                          }, 8, ["color"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.retryCount > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_component_v_icon, {
                            size: "small",
                            class: "mr-1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("mdi-information")
                            ]),
                            _: 1
                          }),
                          _createTextVNode(" Retry attempt " + _toDisplayString(_ctx.retryCount) + " of " + _toDisplayString(_ctx.maxRetries), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.handleRetry,
                      color: "primary",
                      variant: "outlined",
                      disabled: _ctx.retryCount >= _ctx.maxRetries || _ctx.loading,
                      loading: _ctx.loading
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { left: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-refresh")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.retryCount >= _ctx.maxRetries ? 'Max Retries Reached' : 'Try Again'), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled", "loading"]),
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.refreshData,
                      variant: "text",
                      disabled: _ctx.loading
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { left: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-reload")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Reset & Reload ")
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]),
                    _createVNode(_component_v_spacer),
                    (_ctx.error.retryable === false)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          href: "mailto:support@example.com?subject=Roadmap Loading Issue",
                          variant: "text",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => [
                                _createTextVNode("mdi-email")
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" Contact Support ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (_ctx.roadmapData)
          ? (_openBlock(), _createBlock(_component_ErrorBoundary, {
              key: 2,
              "on-error": _ctx.handleErrorBoundaryError,
              "on-retry": _ctx.handleRetry,
              "fallback-message": "The timeline component encountered an error. This might be due to invalid data or a rendering issue."
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (_ctx.roadmapData && _ctx.roadmapData.events)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "timeline-scroll-indicator timeline-scroll-indicator-left",
                        tabindex: "0",
                        role: "button",
                        "aria-label": "Scroll timeline left",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollLeft && _ctx.scrollLeft(...args))),
                        onKeydown: [
                          _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.scrollLeft && _ctx.scrollLeft(...args)), ["enter"])),
                          _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.scrollLeft && _ctx.scrollLeft(...args)), ["prevent"]), ["space"]))
                        ]
                      }, [
                        _createVNode(_component_v_icon, { size: "small" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-chevron-left")
                          ]),
                          _: 1
                        }),
                        _createElementVNode("span", _hoisted_8, "+" + _toDisplayString(_ctx.getHiddenEventsLeft()), 1)
                      ], 544)), [
                        [_vShow, _ctx.getHiddenEventsLeft() > 0]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.roadmapData && _ctx.roadmapData.events)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "timeline-scroll-indicator timeline-scroll-indicator-right",
                        tabindex: "0",
                        role: "button",
                        "aria-label": "Scroll timeline right",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.scrollRight && _ctx.scrollRight(...args))),
                        onKeydown: [
                          _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.scrollRight && _ctx.scrollRight(...args)), ["enter"])),
                          _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.scrollRight && _ctx.scrollRight(...args)), ["prevent"]), ["space"]))
                        ]
                      }, [
                        _createElementVNode("span", _hoisted_9, "+" + _toDisplayString(_ctx.getHiddenEventsRight()), 1),
                        _createVNode(_component_v_icon, { size: "small" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-chevron-right")
                          ]),
                          _: 1
                        })
                      ], 544)), [
                        [_vShow, _ctx.getHiddenEventsRight() > 0]
                      ])
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: "timeline-content",
                      style: _normalizeStyle({ width: _ctx.timelineWidth + 'px' })
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roadmapData.quarters, (quarter) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: `quarter-${quarter.year}-${quarter.quarter}`
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quarter.months, (month, monthIndex) => {
                              return (_openBlock(), _createBlock(_component_TimelineMonth, {
                                key: `month-${month.getTime()}`,
                                month: month,
                                "quarter-color": quarter.backgroundColor,
                                "is-quarter-start": monthIndex === 0,
                                "is-quarter-end": monthIndex === quarter.months.length - 1,
                                "is-selected": _ctx.selectedMonth && _ctx.isSameMonth(month, _ctx.selectedMonth),
                                onMonthClick: _ctx.handleMonthClick
                              }, null, 8, ["month", "quarter-color", "is-quarter-start", "is-quarter-end", "is-selected", "onMonthClick"]))
                            }), 128))
                          ], 64))
                        }), 128))
                      ]),
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roadmapData.events, (event) => {
                          return (_openBlock(), _createBlock(_component_TimelineEvent, {
                            key: event.id,
                            event: event,
                            position: event.position,
                            "is-selected": _ctx.selectedEvent?.id === event.id,
                            "on-select": _ctx.selectEvent,
                            style: _normalizeStyle(_ctx.getEventStyle(event))
                          }, null, 8, ["event", "position", "is-selected", "on-select", "style"]))
                        }), 128))
                      ]),
                      (_ctx.selectedMonth)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "month-events-popup",
                            style: _normalizeStyle(_ctx.getMonthPopupStyle()),
                            onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                          }, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("h3", null, _toDisplayString(_ctx.getSelectedMonthName()), 1),
                              _createVNode(_component_v_btn, {
                                onClick: _ctx.closeMonthPopup,
                                variant: "text",
                                size: "small",
                                icon: "mdi-close"
                              }, null, 8, ["onClick"])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              (_ctx.monthEvents.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, " No events scheduled for this month "))
                                : (_openBlock(), _createElementBlock("table", _hoisted_17, [
                                    _hoisted_18,
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monthEvents, (event) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: event.id,
                                          class: "event-row",
                                          onClick: ($event: any) => (_ctx.selectEventFromMonth(event))
                                        }, [
                                          _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.formatShortDate(event.date)), 1),
                                          _createElementVNode("td", _hoisted_21, _toDisplayString(event.title), 1)
                                        ], 8, _hoisted_19))
                                      }), 128))
                                    ])
                                  ]))
                            ])
                          ], 4))
                        : _createCommentVNode("", true)
                    ], 4)
                  ], 512),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.scrollToStart,
                      variant: "outlined",
                      size: "small",
                      disabled: _ctx.isAtStart
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-chevron-double-left")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" Start ")
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]),
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.scrollToEnd,
                      variant: "outlined",
                      size: "small",
                      disabled: _ctx.isAtEnd
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" End "),
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-chevron-double-right")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"])
                  ]),
                  (_ctx.selectedEvent)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "event-modal-overlay",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeEventModal && _ctx.closeEventModal(...args)))
                      }, [
                        _createVNode(_component_v_card, {
                          class: "event-details-modal",
                          elevation: "8",
                          onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "event-modal-header" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.selectedEvent.title), 1),
                                _createElementVNode("div", _hoisted_24, [
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigateEvent('prev'))),
                                    disabled: !_ctx.canNavigatePrev,
                                    variant: "text",
                                    size: "small",
                                    class: "nav-btn"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-chevron-left")
                                        ]),
                                        _: 1
                                      }),
                                      _createTextVNode(" Prev ")
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]),
                                  _createVNode(_component_v_btn, {
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.navigateEvent('next'))),
                                    disabled: !_ctx.canNavigateNext,
                                    variant: "text",
                                    size: "small",
                                    class: "nav-btn"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Next "),
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-chevron-right")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]),
                                  _createVNode(_component_v_btn, {
                                    onClick: _ctx.closeEventModal,
                                    variant: "text",
                                    size: "small",
                                    class: "close-btn"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-close")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "event-modal-content" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_25, [
                                  _createVNode(_component_v_icon, {
                                    left: "",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-calendar")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.formatEventDate(_ctx.selectedEvent.date)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.selectedEvent.fullDescription), 1),
                                (_ctx.selectedEvent.notes)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      _hoisted_28,
                                      _createTextVNode(" " + _toDisplayString(_ctx.selectedEvent.notes), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.selectedEvent.data)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                      _hoisted_30,
                                      _createTextVNode(" " + _toDisplayString(_ctx.selectedEvent.data), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_actions, { class: "event-modal-footer" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_chip, {
                                  color: _ctx.selectedEvent.position === 'above' ? 'primary' : 'secondary',
                                  size: "small",
                                  variant: "tonal"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.selectedEventIndex + 1) + " of " + _toDisplayString(_ctx.roadmapData.events.length), 1)
                                  ]),
                                  _: 1
                                }, 8, ["color"]),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  onClick: _ctx.closeEventModal,
                                  color: "primary",
                                  variant: "outlined"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Close ")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["on-error", "on-retry"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_31, [
              _createVNode(_component_v_icon, {
                size: "64",
                color: "grey"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("mdi-calendar-blank")
                ]),
                _: 1
              }),
              _hoisted_32,
              _hoisted_33
            ]))
  ]))
}